


























import { Component, Vue, Prop } from 'vue-property-decorator'
import smoothReflow from 'vue-smooth-reflow'

@Component({
	mixins: [smoothReflow],
})
export default class DescriptionBlock extends Vue {
	$refs!: {
		description: Element,
	}
	@Prop({ type: Boolean }) readonly value!: boolean
	@Prop({ type: String }) readonly label!: string
	private isOpened: boolean = false

	get checked() {
		return this.value
	}

	set checked(value: boolean) {
		this.$emit('input', value)
	}

	mounted() {
		this.$smoothReflow!([
			{
				el: this.$refs.description,
				transition: 'height 0.3s ease-in-out',
			},
		])
	}
}
